import { render } from "./BkCrematoria.vue?vue&type=template&id=640ed5d1&scoped=true"
import script from "./BkCrematoria.vue?vue&type=script&lang=js"
export * from "./BkCrematoria.vue?vue&type=script&lang=js"

import "./BkCrematoria.vue?vue&type=style&index=0&id=640ed5d1&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-640ed5d1"]])

export default __exports__